/**
 * Internal dependencies
 */
import * as actions from 'state/action-types';

export default (paytypes) => ({
    type: actions.PAYTYPES_RECEIVE,
    payload: { paytypes },
});